export const invitationStatuses = {
  0: 'In progress',
  1: 'Accepted',
  2: 'Rejected',
  3: 'Withdrawn',
};

export const invitationStatusColors = {
  0: '#EB793F',
  1: '#4CAF50',
  2: '#D32F2F',
  3: '#C4C4C4',
};
